import React from 'react';
import ProductCard from './ProductCard';
import './ProductCard.css';

const FilteredGrid = ({ products }) =>{

    return (
        <div className="product-grid-container">
            <div className="product-grid">
                {products.map((product) => (
                    <ProductCard key={product.id} product={product} />
                ))}
            </div>
        </div>
    );
};

export default FilteredGrid;